import { Options } from '@sheerid/jslib';
import { RecursivePartial } from './lib/types/types';

export const programId = '605cceaac2e5d60065e9875c';

export const defaultOptions: RecursivePartial<Options> = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com',
    },
    logLevel: 'error',
    useFingerprinting: true,
    marketConsent: {
        enabled: true,
    },
    cookies: {
        enabled: true,
        secure: true, // Set to `true` in production when your page uses https
        expires: 18,
        domain: 'onewillow.com',
    },
};
